<div class="h-screen">
  <button
    (click)="save(user, generatedTemplate, action, taskType, keys,sourceTemplateId,sourceTemplateTaskId)">Save</button>
  <quorum-slim-editor *ngIf="originalTemplate" [originalTemplate]="originalTemplate"
    (onTemplateChanged)="generatedTemplate = $event;">
  </quorum-slim-editor>
</div>